import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ThermostatPresetAdjustmentComponent } from '@app/modules/smart-devices/components/thermostat-preset-adjustment/thermostat-preset-adjustment.component';
import {
  ThermostatSetupSuccessComponent,
  ThermostatSetupSuccessWrapperComponent,
} from '@app/modules/smart-devices/components/thermostat-setup-success/thermostat-setup-success.component';
import { DialogConfirmDeviceUnmatchComponent } from '@app/modules/smart-devices/dialogs/dialog-confirm-device-unmatch/dialog-confirm-device-unmatch.component';
import { DeviceSettingsComponent } from '@app/modules/smart-devices/pages/device-settings/device-settings.component';
import { ThermostatSetupSuccessDoneComponent } from '@app/modules/smart-devices/pages/thermostat-setup-success-done/thermostat-setup-success-done.component';
import { ThermostatSetupSuccessLongTermComponent } from '@app/modules/smart-devices/pages/thermostat-setup-success-long-term/thermostat-setup-success-long-term.component';
import { ThermostatSetupSuccessOccupiedComponent } from '@app/modules/smart-devices/pages/thermostat-setup-success-occupied/thermostat-setup-success-occupied.component';
import { ThermostatSetupSuccessPresetsComponent } from '@app/modules/smart-devices/pages/thermostat-setup-success-presets/thermostat-setup-success-presets.component';
import { ThermostatSetupSuccessUnoccupiedComponent } from '@app/modules/smart-devices/pages/thermostat-setup-success-unoccupied/thermostat-setup-success-unoccupied.component';
import { SharedModule } from '../../shared/shared.module';
import { SettingsModule } from '../settings/settings.module';
import { DeviceBatteryStatusComponent } from './components/device-battery-status/device-battery-status.component';
import { SmartDeviceConnectedAccountsTableComponent } from './components/smart-device-connected-accounts-table/smart-device-connected-accounts-table.component';
import { SmartDeviceDevicesTableComponent } from './components/smart-device-devices-table/smart-device-devices-table.component';
import { SmartDeviceGuestsTableComponent } from './components/smart-device-guests-table/smart-device-guests-table.component';
import { SmartDeviceNotificationsComponent } from './components/smart-device-notifications/smart-device-notifications.component';
import { SmartDeviceThermostatPresetsTableComponent } from './components/smart-device-thermostat-presets-table/smart-device-thermostat-presets-table.component';
import { SmartDeviceThermostatsTableComponent } from './components/smart-device-thermostats-table/smart-device-thermostats-table.component';
import { SmartDeviceUnmatchedDevicesTableComponent } from './components/smart-device-unmatched-devices-table/smart-device-unmatched-devices-table.component';
import { DialogAddManualSmartCodeComponent } from './dialogs/dialog-add-manual-smart-code/dialog-add-manual-smart-code.component';
import { DialogCodeReservationDetailsComponent } from './dialogs/dialog-code-reservation-details/dialog-code-reservation-details.component';
import { DialogConnectDeviceComponent } from './dialogs/dialog-connect-device/dialog-connect-device.component';
import { DialogDeleteCodeConfirmationComponent } from './dialogs/dialog-delete-code-confirmation/dialog-delete-code-confirmation.component';
import { DialogDeviceDetailsComponent } from './dialogs/dialog-device-details/dialog-device-details.component';
import { DialogEditDeviceComponent } from './dialogs/dialog-edit-device/dialog-edit-device.component';
import { DeviceDashboardComponent } from './pages/device-dashboard/device-dashboard.component';
import { DeviceSetupSuccessComponent } from './pages/device-setup-success/device-setup-success.component';
import { DeviceSetupComponent } from './pages/device-setup/device-setup.component';
import { DeviceThermostatPresetDetailComponent } from './pages/device-thermostat-preset-detail/device-thermostat-preset-detail.component';
import { DeviceThermostatPresetsComponent } from './pages/device-thermostat-presets/device-thermostat-presets.component';
import { CodeFirstUsedAtPipe } from './pipes/code-first-used-at.pipe';
import { CodeStatusColorPipe } from './pipes/code-status-color.pipe';
import { CodeStatusPipe } from './pipes/code-status.pipe';
import { DeviceIssuesTooltipPipe } from './pipes/device-issues-tooltip.pipe';
import { IntegrationIdToProviderPipe } from './pipes/integration-id-to-provider.pipe';
import { IsThermostatSelectedPipe } from './pipes/is-thermostat-selected.pipe';
import { SmartDeviceIntegrationImagePipe } from './pipes/smart-device-integration-image.pipe';
import { SmartDevicesRoutingModule } from './smart-devices-routing.module';

@NgModule({
  declarations: [
    DeviceDashboardComponent,
    SmartDeviceNotificationsComponent,
    SmartDeviceGuestsTableComponent,
    SmartDeviceDevicesTableComponent,
    SmartDeviceThermostatsTableComponent,
    DeviceSetupComponent,
    DeviceIssuesTooltipPipe,
    CodeStatusColorPipe,
    CodeStatusPipe,
    SmartDeviceConnectedAccountsTableComponent,
    SmartDeviceUnmatchedDevicesTableComponent,
    IntegrationIdToProviderPipe,
    DialogCodeReservationDetailsComponent,
    DialogDeviceDetailsComponent,
    DeviceBatteryStatusComponent,
    DialogAddManualSmartCodeComponent,
    CodeFirstUsedAtPipe,
    DialogConnectDeviceComponent,
    DialogDeleteCodeConfirmationComponent,
    SmartDeviceIntegrationImagePipe,
    DialogEditDeviceComponent,
    DeviceSetupSuccessComponent,
    DialogConfirmDeviceUnmatchComponent,
    DeviceSettingsComponent,
    DeviceThermostatPresetsComponent,
    SmartDeviceThermostatPresetsTableComponent,
    DeviceThermostatPresetDetailComponent,
    IsThermostatSelectedPipe,
    ThermostatSetupSuccessPresetsComponent,
    ThermostatSetupSuccessComponent,
    ThermostatSetupSuccessOccupiedComponent,
    ThermostatSetupSuccessUnoccupiedComponent,
    ThermostatSetupSuccessLongTermComponent,
    ThermostatSetupSuccessDoneComponent,
    ThermostatSetupSuccessWrapperComponent,
    ThermostatPresetAdjustmentComponent,
  ],
  imports: [SmartDevicesRoutingModule, SharedModule, CommonModule, SettingsModule, NgxSliderModule],
})
export class SmartDevicesModule {}
